import React, {
  Component,
  createRef,
  useEffect,
  useRef,
  useState,
} from "react";
import { useRecoilState } from "recoil";
import { isAccountAddCheckModalOpenState } from "../../../recoil/admin/examRoom";
import Modal from "../../modules/layout/Modal";
import useExamRoomActions from "../../../api/hooks/admin/examRoom";
import { useMutation, useQuery } from "@tanstack/react-query";

const AdminAccountAddModal = ({ modalType, userSn }) => {
  // console.log("modalType :", modalType);

  const [isAccountAddCheckModalOpen, setAccountAddCheckModalOpen] =
    useRecoilState(isAccountAddCheckModalOpenState);
  const { createUser } = useExamRoomActions();
  const { getRaterAccount, setRaterAccountChange } = useExamRoomActions();

  // const [isAdmin, setAdmin] = useState(false);
  // const [isRater, setRater] = useState(false);

  const [isAdminOrRater, setAdminOrRater] = useState({
    admin: false,
    rater: false,
  });

  const [account, setAccount] = useState({
    id: "",
    pw: "",
    type: "",
    name: "",
    phone: "",
    email: "",
  });

  // 창을 닫으면 모든 정보를 초기화 함
  useEffect(() => {
    if (isAccountAddCheckModalOpen === false) {
      setAccount({
        id: "",
        pw: "",
        type: "",
        name: "",
        phone: "",
        email: "",
      });
    }
  }, [isAccountAddCheckModalOpen]);

  // useEffect(() => {
  //   console.log("isAdminChange :", isAdmin);
  // }, [isAdmin]);
  //
  // useEffect(() => {
  //   console.log("isRaterChange :", isRater);
  // }, [isRater])

  const { data: userInfo } = useQuery({
    queryKey: ["getUserSn", userSn],
    queryFn: () => getRaterAccount({ sn: userSn }),
    onSuccess: (result) => {
      // console.log("result :", result)
      if (result.status === 200) {
        setAccount({
          ...account,
          id: result.data.id,
          name: result.data.name,
          phone: result.data.phone,
          type: result.data.type,
          email: result.data.email,
          sn: userSn,
        });

        if (result.data.type === 0) {
          setAdminOrRater({
            ...isAdminOrRater,
            admin: true,
            rater: false,
          });
        } else {
          // setAdmin(false);
          // setRater(true);
          setAdminOrRater({
            ...isAdminOrRater,
            admin: false,
            rater: true,
          });
        }
      }

      // console.log("isaccount :", account);
    },
    enabled: !!userSn,
  });

  const onChangeAccount = (e) => {
    setAccount({
      ...account,
      [e.target.name]: e.target.value,
    });
  };

  const onOnclickAccount = (e) => {
    setAccount({
      ...account,
      [e.target.name]: e.target.value,
    });
  };

  const resultCreateUser = useMutation(createUser, {
    onSuccess: (result) => {
      if (result.status === 200) {
        alert("생성에 성공하였습니다");
        setAccountAddCheckModalOpen(false);
        window.location.reload();
      } else {
        if (result.response.status === 400) {
          alert(result.response.data.text);
        } else {
          alert("예상치 못한 에러가 발생했습니다. 잠시후 시도해주세요.");
        }
      }
    },
    onError: () => {
      alert("예상치 못한 에러가 발생했습니다. 잠시후 시도해주세요.");
    },
  });

  const postCreateUser = () => {
    const req = {
      id: account.id,
      pw: account.pw,
      name: account.name,
      phone: account.phone,
      email: account.email,
    };
    // console.log("account1", account);
    if (account.name === "") {
      alert("이름을 입력해주세요");
      return;
    }

    // if (account.type === "") {
    //   alert("타입을 선택해 주세요");
    //   return;
    // }

    if (account.id === "") {
      alert("아이디를 입력해주세요");
      return;
    }

    if (account.pw === "") {
      alert("비밀번호를 입력해주세요");
      return;
    }

    resultCreateUser.mutate(req);
  };

  const resultModifyUser = useMutation(setRaterAccountChange, {
    onSuccess: (result) => {
      if (result.status === 200) {
        alert("정보가 변경되었습니다.");
        setAccountAddCheckModalOpen(false);
        window.location.reload();
      } else {
        if (result.response.status === 400) {
          alert(result.response.data.text);
        } else {
          alert("예상치 못한 에러가 발생했습니다. 잠시후 시도해주세요.");
        }
      }
    },
    onError: () => {
      alert("예상치 못한 에러가 발생했습니다. 잠시후 시도해주세요.");
    },
  });

  const postModifyUser = () => {
    // console.log("postModifyUser :", account);

    if (account.pw === "") {
      alert("비밀번호를 입력해주세요");
      return;
    }

    resultModifyUser.mutate(account);
  };

  return (
    <Modal isOpen={isAccountAddCheckModalOpen}>
      <div className="modal fade" id="AccountAdd" style={{ display: "block" }}>
        <div className="modal-content" style={{ width: "450px" }}>
          {/* <div className="modal-header flex">
            <div className="modal-title">
              <p>영어말하기 모의평가</p>
            </div>
          </div> */}
          <div className="modal-body confirm-sec">
            <div className="modal-title">
              {modalType ? <p>계정추가</p> : <p>계정수정</p>}
            </div>
            <div className="modal-cont">
              <div className="plus-box">
                <p className="plus-title">아이디</p>
                {modalType ? (
                  <>
                    <input
                      name="id"
                      type="text"
                      className="plus-title-input"
                      style={{ width: "100%" }}
                      onChange={onChangeAccount}
                    />
                  </>
                ) : (
                  <>
                    <input
                      name="id"
                      type="text"
                      className="plus-title-input"
                      style={{ width: "100%" }}
                      onChange={onChangeAccount}
                      value={userInfo?.data?.id || ""}
                      readOnly={true}
                    />
                  </>
                )}
                {/*<input*/}
                {/*  name="id"*/}
                {/*  type="text"*/}
                {/*  className="plus-title-input"*/}
                {/*  style={{width: "100%"}}*/}
                {/*  onChange={onChangeAccount}*/}
                {/*  defaultValue={userInfo?.data?.id || ""}*/}
                {/*/>*/}
              </div>
              <div className="plus-box">
                <p className="plus-title">이름</p>
                <input
                  name="name"
                  type="text"
                  className="plus-title-input"
                  style={{ width: "100%" }}
                  onChange={onChangeAccount}
                  defaultValue={userInfo?.data?.name || ""}
                />
              </div>
              <div className="plus-box">
                <p className="plus-title">연락처</p>
                <input
                  name="phone"
                  type="text"
                  className="plus-title-input"
                  style={{ width: "100%" }}
                  onChange={onChangeAccount}
                  defaultValue={userInfo?.data?.phone || ""}
                />
              </div>
              <div className="plus-box">
                <p className="plus-title">이메일</p>
                <input
                  name="email"
                  type="text"
                  className="plus-title-input"
                  style={{ width: "100%" }}
                  onChange={onChangeAccount}
                  defaultValue={userInfo?.data?.email || ""}
                />
              </div>
              <div className="plus-box">
                <p className="plus-title">비밀번호</p>
                <input
                  name="pw"
                  type="text"
                  className="plus-title-input"
                  style={{ width: "100%" }}
                  onChange={onChangeAccount}
                />
              </div>
            </div>

            <div className="modal-footer flex" style={{ padding: "20px 0" }}>
              <div>
                {/* 수정일때만 있음 */}
                <button
                  style={{ display: "none" }}
                  className="modal-btn modal-close-btn account-del"
                >
                  계정 삭제
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="modal-btn modal-close-btn"
                  onClick={() => {
                    setAccountAddCheckModalOpen(false);
                  }}
                >
                  닫기
                </button>
                {modalType ? (
                  <>
                    <button
                      type="button"
                      className="modal-btn modal-save-btn"
                      onClick={postCreateUser}
                    >
                      추가
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      className="modal-btn modal-save-btn"
                      onClick={postModifyUser}
                    >
                      수정
                    </button>
                  </>
                )}
                {/*<button*/}
                {/*  type="button"*/}
                {/*  className="modal-btn modal-save-btn"*/}
                {/*  onClick={postCreateUser}*/}
                {/*>*/}
                {/*  {modalType ? "추가" : "수정"}*/}
                {/*</button>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default AdminAccountAddModal;
